import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import ModalBasic from "../components/ModalBasic";
import ModalLoading from "../components/ModalLoading";
import axios from "axios";
import { HEADER } from "../utils/Utils";
import Footer from "../components/Footer";
import ButtonRequire from "../components/Button/ButtonRequire";

export default function ConfirmOTP() {
  const [otp, setOtp] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [counter, setCounter] = useState(30);
  // navigate
  const navigate = useNavigate();
  // location
  const { state } = useLocation();
  const { email } = state ?? "";

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const handleChange = (e) => {
    var target = e.srcElement || e.target;
    var maxLength = parseInt(target.attributes["maxlength"].value, 10);
    var myLength = target.value.length;
    var value = [];
    value = otp;

    if (myLength >= maxLength) {
      value.push(e.target.value);
      var next = target;
      while ((next = next.nextElementSibling)) {
        if (next == null) {
          break;
        }
        if (next.tagName.toLowerCase() === "input") {
          next.focus();
          break;
        }
      }
    }
    // Move to previous field if empty (user pressed backspace)
    else if (myLength === 0) {
      value.pop();
      var previous = target;
      while ((previous = previous.previousElementSibling)) {
        if (previous == null) {
          break;
        }
        if (previous.tagName.toLowerCase() === "input") {
          previous.focus();
          break;
        }
      }
    }

    setOtp(value);
    if (value.length === 4) {
      ConfirmOTP(e);
    }
  };

  function ConfirmOTP(e) {
    e.preventDefault();
    setShowModalLoading(true);
    // join otp
    var code = _.join(otp, "");

    // verification otp code
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL_API}/v2/account/signin/ppv/verification`,
        {
          param: email,
          code: code,
        },
        { headers: HEADER }
      )
      .then(async (res) => {
        try {
          let user = res.data.data;
          if (!_.isEmpty(user)) {
            // GET DETAIL OUTLET
            let outlet = await axios.get(
              `${process.env.REACT_APP_BASE_URL_API}/outlet/kartini/${user.outlet_kartini_id}`,
              { headers: HEADER }
            );
            outlet = outlet.data.data;

            let channel = await axios.get(
              `${process.env.REACT_APP_BASE_URL_API}/channel/${outlet.channel_id}`,
              { headers: HEADER }
            );
            channel = channel.data.data;

            if (user.status === "initial") {
              navigate("/register", {
                state: { user, outlet, channel },
                replace: true,
              });
            } else {
              localStorage.setItem("dompet_user", JSON.stringify(user));
              localStorage.setItem(
                "dompet_detail_outlet",
                JSON.stringify({ ...outlet, ...channel })
              );
              navigate("/", { state: { email }, replace: true });
            }
          } else {
            navigate(-1);
          }
          setShowModalLoading(false);
        } catch (error) {
          console.error(error);
          setShowModalLoading(false);
          setShowModal(true);
        }
      })
      .catch((error) => {
        console.error(error);
        setShowModalLoading(false);
        setShowModal(true);
      });
  }

  function ResendOTP(e) {
    e.preventDefault();
    setShowModalLoading(true);

    // RESEND OTP
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL_API}/v2/account/signin/ppv/index`,
        {
          param: email,
        },
        { headers: HEADER }
      )
      .then((res) => {
        setShowModalLoading(false);
        // set counter to resend email again
        setCounter(60);
      })
      .catch((error) => {
        console.error(error);
        setShowModalLoading(false);
      });
  }

  return (
    <>
      {!email ? (
        <Navigate to="/signin" />
      ) : (
        <>
          <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
          />
          <ModalBasic
            id="message-confirm-modal"
            modalOpen={showModal}
            setModalOpen={setShowModal}
            title="Wrong OTP"
            enClose={true}
          >
            <div className="px-5 py-4">
              <p className="text-gray-500">
                Wrong otp and check your otp again
                <span className="text-indigo-500 font-medium"> {email}</span>
              </p>
            </div>
          </ModalBasic>
          <div className="relative space-y-10">
            <Header title="Vertify Email" />
            <div className="px-4 py-8 bg-white">
              <p className="text-gray-700 text-center mb-6">
                OTP code is sent to your email
              </p>
              {/* Form */}
              <form>
                <div className="space-y-4">
                  <div className="otp flex justify-between space-x-5">
                    <input
                      id="0"
                      className="form-input w-full text-center font-bold text-gray-700 text-3xl h-14"
                      type="number"
                      maxLength={1}
                      onChange={handleChange}
                    />
                    <input
                      id="1"
                      className="form-input w-full text-center font-bold text-gray-700 text-3xl h-14"
                      type="number"
                      maxLength={1}
                      onChange={handleChange}
                    />
                    <input
                      id="2"
                      className="form-input w-full text-center font-bold text-gray-700 text-3xl h-14"
                      type="number"
                      maxLength={1}
                      onChange={handleChange}
                    />
                    <input
                      id="3"
                      className="form-input w-full text-center font-bold text-gray-700 text-3xl h-14"
                      type="number"
                      maxLength={1}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="flex flex-col mt-5 space-y-2">
                  <ButtonRequire
                    title="CONFIRM OTP"
                    functionOnClick={ConfirmOTP}
                    isDisabled={otp.length !== 4}
                  />
                </div>
                {/* counter resend otp code */}
                {counter !== 0 && (
                  <p className="text-center mt-5 mb-2">{`${counter}`}</p>
                )}
                <div className="pt-3">
                  <div className="text-sm text-center space-x-1">
                    <span>Did not recive OTP?</span>
                    <button
                      className="font-medium text-[#4CA6F8]  disabled:text-gray-400"
                      disabled={counter === 0 ? false : true}
                      onClick={(e) => ResendOTP(e)}
                    >
                      Click Here
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="w-full mx-auto fixed bottom-0 pb-3">
              <Footer color="gray-400" />
            </div>
          </div>
        </>
      )}
    </>
  );
}
